import Loader from "../ui/Loader.js";
import Heading from "..//ui/Heading.js";
import { useTop5Videos } from "../../hooks/useTop5Videos.js";
import TopFiveSliderDisplay from "../TopFiveSliderDisplay/TopFiveSliderDisplay.js";

const TopFiveSlider = () => {
  const { top5, isLoading, error, refetch } = useTop5Videos();

  return (
    <section>
      {/* <Heading>What's Hot? </Heading> */}

      {isLoading ? (
        <Loader />
      ) : error ? (
        <div className="text-red-500">
          {error.message || "Error fetching Top 5 videos"}
          <button
            onClick={refetch}
            className="ml-4 underline text-sm text-white hover:text-red-400 transition"
          >
            Riprova
          </button>
        </div>
      ) : !top5?.length ? (
        <div className="text-gray-400 italic">No Top 5 video disponibili.</div>
      ) : (
        <TopFiveSliderDisplay videos={top5} />
      )}
    </section>
  );
};

export default TopFiveSlider;
